<template>
  <div id="letDownScreen">
    <div id="letDown">
      <div class="letDownWrap">
        <div class="logoTitle">
          <img class="logo" src="@/assets/images/login/logo.png" alt="">
          <img class="title" src="@/assets/images/login/title_picture.png" alt="">
        </div>
        <div class="letDownBox">
          <div class="title" style="position: relative;height:66px">
            <div style="display: flex; align-items: center;  font-size:25px;margin:15px 0">
                            <span @click="iconBack"
                                  style="display: flex;align-items: center;cursor:pointer;position:absolute;z-index:999">
                                <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
                            </span>
              <div class="title-content" style="width:900px; position:absolute; left:-24px">
                <div style="text-align:center">中国足球协会精英青训教练员应聘报名</div>
                <div style="text-align:center; font-size:14px; color:#4cd964;margin-top:5px">
                  <span style="cursor:pointer;font-size:16px" @click="findProcess">下载：中国足协关于2021年聘请第一批专职精英青训教练员的通知</span>
                </div>
              </div>

            </div>
          </div>
          <div class="form-wrap recruitment">
            <vue-scroll>
              <div class="scroll-content">
                <el-form :model="formData" ref="vitaForm" :rules="Inforules" label-width="100px" color="white"
                         size="medium">
                  <fieldset class="qualification-form-fieldset">
                    <legend>中国足协精英青训教练员应聘报名表</legend>

                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="证件类型" class="w_90" prop="idType"  style="position: relative; ">
                          <el-select v-model="formData.idType"
                                     placeholder="请选择证件类型"
                                     style="width: 100%;" @change="changeType()">
                            <el-option
                              v-for="(item, index) in id_types"
                              :key="index"
                              :label="item.key"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <div class="example" v-if="formData.idType === 'IDTYPECODEWGJZZ'">
                            <p class="intro">示例</p>
                            <div class="showExample" >
                              <p class="nameExample">外国人永久居留身份证</p>
                              <div class="img">
                                <img :src="wgjzz" alt="">
                              </div>
                            </div>
                          </div>
                          <div class="example" v-if="formData.idType === 'IDTYPECODEHMT'">
                            <p class="intro">示例</p>
                            <div class="showExample" >
                              <p class="nameExample">港澳台居民居住证</p>
                              <div class="img">
                                <img :src="HMT" alt="">
                              </div>
                            </div>
                          </div>
                          <div class="example" v-if="formData.idType === 'HM'">
                            <p class="intro">示例</p>
                            <div class="showExampledouble" >
                              <p class="nameExample">港澳居民来往内地通行证</p>
                              <div class="img">
                                <div class=""  class="section">
                                  <p class="l_title">港澳居民来往内地通行证示例（1999版）</p>
                                  <img :src="HM1999" alt="">
                                </div>
                                <div style="margin-left: 10px" class="section">
                                  <p class="l_title">港澳居民来往内地通行证示例（2012版）</p>
                                  <img :src="HM2012" alt="">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="example" v-if="formData.idType === 'TAI'">
                            <p class="intro">示例</p>
                            <div class="showExampledouble" >
                              <p class="nameExample">台湾居民来往大陆通行证</p>
                              <div class="img">
                                <div class=""  class="section">
                                  <p class="l_title">台湾居民来往大陆通行证（2002版）</p>
                                  <img :src="TAI2002" alt="">
                                </div>
                                <div style="margin-left: 10px" class="section">
                                  <p class="l_title">台湾居民来往大陆通行证（2015版）</p>
                                  <img :src="TAI2015" alt="">
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="证件号码" class="w_100" prop="idNumber">
                          <el-input v-model="formData.idNumber" :placeholder="id_numberMsg" @blur="idNumberBlur(formData.idNumber)"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>


                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="姓名" prop="idName" class="w_100">
                          <el-input v-model="formData.idName" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="国籍" class="w_100" prop="idCountry" v-if="this.formData.idType==='PASSPORT'">
                          <el-select v-model="formData.idCountry"
                                     placeholder="请选择国家/地区"
                                     style="width: 100%;"
                                     filterable>
                            <el-option
                              v-for="item in allCountry"
                              :key="item.country_code"
                              :label="item.country_zh"
                              :value="item.country_code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="国籍" class="w_100" prop="idCountry"
                                      v-if="this.formData.idType !=='PASSPORT' && this.formData.idType !==''">
                          <el-select v-model="formData.idCountry"
                                     style="width: 100%;">
                            <el-option
                              key="CN"
                              label="中国"
                              value="CN">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>



                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="性别" class="w_100" prop="gender" >
                          <el-select v-model="formData.gender"
                                     :disabled="formData.idType === 'IDNUMBER'"
                                     placeholder="请选择性别"
                                     style="width: 100%;">
                            <el-option
                              v-for="(item, index) in genderList"
                              :key="index"
                              :label="item.key"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="出生年月" class="w_100" prop="birthday">
                          <el-date-picker
                            :disabled="formData.idType === 'IDNUMBER'"
                            class="w_100"
                            v-model="formData.birthday"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="学历" class="w_100" prop="educationBackground">

                          <el-select v-model="formData.educationBackground"
                                     placeholder="请输入学历背景"
                                     style="width: 100%;">
                            <el-option
                              v-for="(item,index) in educationList"
                              :key="index"
                              :label="item.key"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="教练等级" class="w_100" prop="coachingLevel">
                          <el-select class="w_100" v-model="formData.coachingLevel" placeholder="请选择教练等级">
                            <el-option v-for="(level, index) in coachingLevels" :key="index" :label="level.key" :value="level.value"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="手机号码" class="w_100" prop="phone">
                          <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="电子邮箱" class="w_100" prop="email">
                          <el-autocomplete v-model="formData.email" class="w_100" :fetch-suggestions="querySearch" placeholder="请输入电子邮箱"></el-autocomplete>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row class=""  >
                      <el-col :span="6" v-if="formData.idType === 'IDNUMBER'">
                        <el-form-item label="籍贯" class="w_l_120" prop="provinceId">
                          <el-select v-model="formData.provinceId" class="w_100" placeholder="请选择省份">
                            <el-option
                              v-for="(item,index) in regions"
                              :key="index"
                              :value="item.code"
                              :label="item.name"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" v-if="formData.idType === 'IDNUMBER'">
                        <el-form-item label-width="60px"  class="w_100" prop="cityId"
                                      :rules="{ required: true, message: '请选择城市', trigger: 'change' }">
                          <el-select v-model="formData.cityId" class="w_100" :disabled="!formData.provinceId" placeholder="请选择城市">
                            <el-option
                              v-for="(item,index) in city"
                              :key="index"
                              :value="item.code"
                              :label="item.name"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="12">
                        <el-form-item label="执教年限" class="w_90" prop="coachingDuration" style="position: relative">
                          <el-input v-model.number="formData.coachingDuration" placeholder="请输入执教年限"></el-input>
                          <div style="position: absolute; right: -20px; top: 0px;">年</div>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="执照有效期" class="w_100" prop="certification"  style="position: relative">
                          <el-date-picker
                            class="w_100"
                            value-format="yyyy"
                            v-model="formData.certification"
                            type="year"
                            placeholder="请选择教练员执照有效期">
                          </el-date-picker>
                          <div style="position: absolute; right: -80px; top: 0px;">年12月31号</div>
                        </el-form-item>
                      </el-col>
                    </el-row>


                    <el-form-item label="报名表" class="w_80" required :error="applicationError">
                      <el-upload
                        :action="uploadExcelUrl"
                        :data="imageData"
                        :before-upload="beforeExcelUpload"
                        :on-remove="handleApplicationRemove"
                        :limit="1"
                        :on-exceed="handleApplicationExceed"
                        :on-success="handleApplicationSuccess"
                        :file-list="applicationList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传excel文件
                          <div class="download-box" @click="downloadFile">下载模板</div>
                        </div>
                      </el-upload>
                    </el-form-item>

                    <el-form-item label="健康证明" class="w_80" required :error="healthyError">
                      <el-upload
                        :action="uploadFileUrl"
                        :data="imageData"
                        :before-upload="beforeFileUpload"
                        :on-remove="handleHealthyDocRemove"
                        :limit="1"
                        :on-exceed="handleHealthyDocExceed"
                        :on-success="handleHealthyDocSuccess"
                        :file-list="healthyDocList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传近三个月内三级甲等医院开具的健康体检证明（pdf格式）</div>
                      </el-upload>
                    </el-form-item>

                    <el-form-item label="教练员证书" class="w_80"  :error="certificateError">
                      <el-upload
                        :action="uploadUrl"
                        :data="imageData"
                        :before-upload="beforeUpload"
                        :on-remove="handleCertificateDocRemove"
                        :limit="1"
                        :on-exceed="handleCertificateDocExceed"
                        :on-success="handleCertificateDocSuccess"
                        :file-list="certificateList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                      </el-upload>
                    </el-form-item>

                    <el-form-item label="教练员执照" class="w_80" :error="listensesError">
                      <el-upload
                        :action="uploadUrl"
                        :data="imageData"
                        :before-upload="beforeUpload"
                        :on-remove="handleListensesDocRemove"
                        :limit="1"
                        :on-exceed="handleListensesDocExceed"
                        :on-success="handleListensesDocSuccess"
                        :file-list="listensesList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                      </el-upload>
                    </el-form-item>
                  </fieldset>
                </el-form>
              </div>
            </vue-scroll>
          </div>
          <div class="btns">
            <el-button type="primary" @click="checkForm">提交
            </el-button>
            <el-button type="danger" @click="cancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>

    <yioks-tips :showTip="tipsFlag" tipMsg="请确认提交？" :loading="repeatSubmit" @callback="hideTipsDialog"></yioks-tips>
    <yioks-tips :showTip="cancelFlag" tipMsg="请确认取消提交？" @callback="goBack"></yioks-tips>
  </div>
</template>

<script>
  import 'vue-awesome/icons/regular/arrow-alt-circle-left'
  import talentOpinion from '@/api/talentOpinion/talentOpinion'
  import rules from '@/utils/formRules/rules'
  import { ops } from '@/utils/scrollIndialog'
  import { id_types, coachingLevel, educationList, genderList } from '@/utils/yioks_data'
  import { countryArr } from '@/utils/country'
  import regions from '@/utils/regions'
  import { filterIdNumber } from '@/utils/yioks_filter'
  import recruitmentApi from '@/api/recruitment/index'
  import { downloadByJs } from '@/utils/commen'

  import wgjzz from '@/assets/images/tips/wgjzz.png'
  import HMT from '@/assets/images/tips/HMT.png'
  import HM1999 from '@/assets/images/tips/HM1999.png'
  import HM2012 from '@/assets/images/tips/HM2012.png'
  import TAI2002 from '@/assets/images/tips/TAI2002.png'
  import TAI2015 from '@/assets/images/tips/TAI2015.png'

  export default {
    name: 'Recruitment',

    data () {
      return {
        downloadUrl: '/uploads/templateFile/报名表.xlsx',
        downloadName: '报名表模板.xlsx',
        wgjzz,
        HMT,
        HM1999,
        HM2012,
        TAI2002,
        TAI2015,

        staticUrl: '/uploads/templateFile/中国足协关于2021年聘请第一批专职精英青训教练员的通知.pdf',

        uploadUrl: '/api/zuxie/guozi/upload/image',  // 文件上传地址
        uploadFileUrl: '/api/zuxie/guozi/upload/file',
        uploadExcelUrl: '/api/zuxie/guozi/upload/file',
        ops,
        tipsFlag: false,
        repeatSubmit: false,
        cancelFlag: false,
        id_types,
        regions,
        educationList,
        genderList,
        city: [],
        allCountry: countryArr.slice(1),
        coachingLevels: coachingLevel,
        formData: {
          idName: '',
          idCountry: 'CN',
          idType: 'IDNUMBER',
          idNumber:'',
          provinceId: '',
          cityId: '',
          educationBackground: '',
          coachingLevel: '',
          coachingDuration: '',
          certification: '',
          phone: '',
          email:'',
          gender:'',
          birthday: '',
        },
        applicationList: [],  // 报名表上传列表
        signupUrl: '',
        healthyDocList: [],   // 健康证明
        medicalUrl: '',
        listensesList: [], // 执照地址列表
        licenseUrl: '',
        certificateList: [], // 证书列表
        certificateUrl: '',
        Inforules: {
          idName: [
            { required: true, message: '姓名不能为空', trigger: 'blur'}
          ],
          idType: [
            { required: true, message: '证件类型不能为空', trigger: 'blur'}
          ],
          idCountry: [
            { required: true, message: '国籍不能为空', trigger: 'blur'}
          ],
          idNumber: [
            { required: true,
              validator: (rule, value, callback) => {
                const IDTYPE = this.formData.idType;
                // console.log('idNumber validator idType', IDTYPE);
                if (value) {
                  let validatorFun = null;
                  switch (IDTYPE) {
                    case 'IDNUMBER':
                      validatorFun = rules.idNumber;
                      break;
                    case 'IDTYPECODEWGJZZ':  //外国人永久居留证
                      validatorFun = rule.checkPassport;
                      break;
                    case 'IDTYPECODEHMT':
                      validatorFun = null;
                      break;
                    case 'HM':
                      validatorFun = rule.checkHkongMacao;
                      break;
                    case 'TAI':
                      validatorFun = rule.checkTaiwOld;
                      break;
                    case 'PASSPORT':
                      validatorFun = rule.checkPassport;
                      break;
                    default:
                      validatorFun = null;
                      break;
                  }
                  if (validatorFun) {
                    if (validatorFun(value)) {
                      callback()
                    }else {
                      callback(new Error('请输入正确的证件号码'))
                    }
                  }else {
                    callback();
                  }
                } else {
                  callback(new Error('证件号不能为空'));
                }
              }, trigger: 'blur'}
          ],
          gender: [ { required: true, message: '性别不能为空', trigger: 'change'}],
          birthday: [ { required: true, message: '出生年月不能为空', trigger: 'change'}],
          provinceId: [{ required: true, message: '籍贯不能为空', trigger: 'change'}],
          cityId: [{ required: true, message: '籍贯不能为空', trigger: 'change'}],
          educationBackground: [ { required: true, message: '教育背景不能为空', trigger: 'change'} ],
          coachingLevel: [ { required: true, message: '教练等级不能为空', trigger: 'change'} ],
          coachingDuration: [
            { required: true, message: '执教年限不能为空', trigger: 'blur'},
            {type: 'number', message: '年龄必须为数字值'}
          ],
          certification: [ { required: true, message: '证件有效期不能为空', trigger: 'blur'}, ],
          phone: [
            { required: true, message: '手机号不能为空', trigger: 'blur'},
            {
              validator: (rule, value, callback) => {
                if (value) {
                  if (rules.phone(value)) {
                    callback();
                  }else {
                    callback(new Error('请输入正确的手机号'))
                  }
                } else {
                  callback(new Error('手机号不能为空'))
                }
              },
              trigger: 'blur'
            }
          ],
          email: [
            { required: true, message: '邮箱不能为空', trigger: 'change'},
            { validator: (rule, value, callback) => {
                if (value) {
                  if (rules.checkEmail(value)) {
                    callback();
                  } else {
                    callback( new Error('请输入正确的邮箱'))
                  }
                } else {
                  callback(new Error('邮箱不能为空'))
                }
              },
              trigger: 'change'
            }
          ]
        },
        applicationError: '',
        healthyError: '',
        certificateError: '',
        listensesError: '',
        id_numberMsg: '请输入身份证号',
        imageData: { image: '' },
      }
    },
    watch: {
      'formData.provinceId': {
        handler (val) {
          this.regions.forEach(item => {
            if (item.code === val) {
              this.city = item.city
              this.formData.cityId = this.city[0].code
            }
          })
        }
      }
    },
    components: {
      // 'v-icon': () => import('vue-awesome/components/Icon'),
      'yioks-tips': () => import('@/components/YioksTip')
    },
    created () {

    },
    methods: {
      iconBack () {
        this.$router.go(-1)
      },
      findProcess () {
        window.open(this.staticUrl)
      },
      checkForm () {
        this.$refs['vitaForm'].validate((valid) => {
          this.validatorForDoc(); // 注意，有返回值
          if (valid) {
            if (this.validatorForDoc()) {
              this.tipsFlag = true
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      querySearch(queryString, cb) {
        if (queryString.indexOf('@') > -1){
          cb([])
        }else{
          let res =[
            { "value": queryString + '@qq.com', "address": queryString + '@qq.com' },
            { "value": queryString + '@163.com', "address": queryString + '@163.com' },
            { "value": queryString + '@126.com', "address": queryString + '@126.com' },
            { "value": queryString + '@sina.com', "address": queryString + '@sina.com' },
            { "value": queryString + '@yioks.com', "address": queryString + '@yioks.com' },
            { "value": queryString + '@mail.com', "address": queryString + '@mail.com' },
            { "value": queryString + '@sohu.com', "address": queryString + '@sohu.com' },
            { "value": queryString + '@sogou.com', "address": queryString + '@sogou.com' },
          ]
          let  results = queryString ? res  : [];
          // 调用 callback 返回建议列表的数据
          cb(results);
        }


      },

      hideTipsDialog (bool) {
        if (bool) {
          if (!this.repeatSubmit) {
            this.repeatSubmit = true
            const { idName, idType, idCountry, idNumber, gender,
              birthday, provinceId, cityId, educationBackground,
              coachingLevel, coachingDuration, certification, phone, email
            } = this.formData;
            const submitData = {
              idName,
              gender,
              birthday: new Date(birthday).getTime(),
              idCountry,
              provinceId,
              cityId,
              education: educationBackground,
              coachLevel: coachingLevel,
              teachingYear: coachingDuration,
              certificateExpire: certification,
              phone,
              email,
              idNumber,
              idType,
              certificateUrl: this.certificateUrl,
              licenseUrl: this.licenseUrl,
              signupUrl: this.signupUrl,
              medicalUrl: this.medicalUrl
            };
            recruitmentApi.submitApplication(submitData).then(res => {
              if (res.code) {
                this.$message.error(res.msg)
                this.tipsFlag = false
                this.repeatSubmit = false
                return
              }
              this.$message.success('报名表提交成功');
              this.tipsFlag = false
              this.$router.go(-1)
              this.repeatSubmit = false
              this.$refs['vitaForm'].clearValidate();
            }).catch( err => {
              console.log('err', err)
              this.repeatSubmit = false
              this.tipsFlag = false
            })
          }

        } else {
          this.repeatSubmit = false
          this.tipsFlag = false
        }
      },
      cancel () {
        this.cancelFlag = true
      },
      goBack (isSure) {
        if (isSure) {
          this.$router.go(-1)
        }
        this.cancelFlag = false
      },
      // 证件类型
      changeType () {
        switch (this.formData.idType) {
          case 'IDNUMBER': // 身份证
            this.formData.idCountry = 'CN'
            this.id_numberMsg = '请输入身份证号'
            break
          case 'IDTYPECODEWGJZZ': // 外国人永久居留身份证
            this.formData.idCountry = 'CN'
            this.id_numberMsg = '例如：CAN000000000000'
            break
          case 'IDTYPECODEHMT': // 港澳台居民居住证
            this.formData.idCountry = 'CN'
            this.id_numberMsg = '请输入港澳台居民居住证号'
            break
          case 'HM': // 港澳居民来往内地通行证
            this.formData.idCountry = 'CN'
            this.id_numberMsg = '例如：H00000000'
            break
          case 'TAI': // 台湾居民来往大陆通行证
            this.formData.idCountry = 'CN'
            this.id_numberMsg = '例如：00000000'
            break
          case 'PASSPORT': // 护照（非中国大陆人员）
            this.formData.idCountry = ''
            this.id_numberMsg = '例如：E00000000'
            break
        }
      },
      // 报名表上传太多
      handleApplicationExceed(file, fileList) {
        this.$message.warning('只允许上传一个文件');
      },
      // 移除报名表
      handleApplicationRemove(file, fileList) {
        this.applicationList = fileList;
        this.signupUrl = '';
      },
      // 报名上传前校验 = 暂时不用
      beforeApplicationUpload(file) {
        const imageReg = /^image\/(jpeg|jpg|png|gif)$/i
        const imageType = imageReg.test(file.type)
        const imageLimit = file.size / 1024 / 1024 < 10

        if (!imageType) {
          this.$message.error(this.$t('uploadFormat'))
        }
        if (!imageLimit) {
          this.$message.error(this.$t('fileSizeLimit'))
        }
        if (imageType && imageLimit) {
          this.$set(this.imageData, 'image', file)
        }
        return imageType && imageLimit
      },
      // 上传成功
      handleApplicationSuccess(response, file, fileList) {
        this.applicationList = fileList;
        this.signupUrl = response;
        this.applicationError = '';
      },
      // 健康证明 移除
      handleHealthyDocRemove(file, fileList) {
        this.healthyDocList = fileList;
        this.medicalUrl = '';
      },
      // 健康证明校验 = 暂时不用
      beforeHealthyUpload(file) {
        const imageReg = /^image\/(jpeg|jpg|png|gif)$/i
        const imageType = imageReg.test(file.type)
        const imageLimit = file.size / 1024 / 1024 < 10

        if (!imageType) {
          this.$message.error(this.$t('uploadFormat'))
        }
        if (!imageLimit) {
          this.$message.error(this.$t('fileSizeLimit'))
        }
        if (imageType && imageLimit) {
          this.$set(this.imageData, 'image', file)
        }
        return imageType && imageLimit
      },
      // 健康证明
      handleHealthyDocExceed(file) {
        this.$message.warning('只允许上传一个文件');
      },
      // 健康证明
      handleHealthyDocSuccess(response, file, fileList) {
        this.healthyDocList = fileList;
        this.medicalUrl = response;
        this.healthyError = '';
      },
      // 处理身份证号相关
      idNumberBlur(val) {
        if (this.formData.idType === 'IDNUMBER' && rules.idNumber(val)) {
          const gender = filterIdNumber(val, 1);
          const birth = filterIdNumber(val,0)
          this.$set(this.formData, 'gender', gender);
          this.$set(this.formData, 'birthday', birth);
          this.$refs['vitaForm'].validateField( [ 'gender', 'birthday'])
        }
      },

      handleCertificateDocRemove(file, fileList) {
        this.certificateUrl = '';
        this.certificateList = [];
      },
      handleCertificateDocExceed(file, fileList) {
        this.$message.warning('只允许上传一个文件');
      },
      handleCertificateDocSuccess(response, file, fileList ) {
        this.certificateList = fileList;
        this.certificateUrl = response;
      },
      handleListensesDocRemove(file, fileList) {
        this.licenseUrl = '';
        this.listensesList = fileList;
      },
      handleListensesDocExceed(file, fileList) {
        this.$message.warning('只允许上传一个文件');
      },
      handleListensesDocSuccess(response, file, fileList) {
        this.listensesList = fileList;
        this.licenseUrl = response;
      },

      beforeUpload(file) {
        const imageReg = /^image\/(jpeg|jpg|png|gif)$/i
        const imageType = imageReg.test(file.type)
        const imageLimit = file.size / 1024 / 1024 < 10

        if (!imageType) {
          this.$message.error(this.$t('uploadFormat'))
        }
        if (!imageLimit) {
          this.$message.error(this.$t('fileSizeLimit'))
        }
        if (imageType && imageLimit) {
          this.$set(this.imageData, 'image', file)
        }
        return imageType && imageLimit
      },

      // pdf 文件上传
      beforeFileUpload(file) {
        const fileReg = /^application\/pdf$/i
        const fileType = fileReg.test(file.type)
        const fileLimit = file.size / 1024 / 1024 < 10

        if (!fileType) {
          this.$message.error('请上传pdf文件')
        }
        if (!fileLimit) {
          this.$message.error(this.$t('fileSizeLimit'))
        }
        return fileType && fileLimit
      },

      // excel文件上传
      beforeExcelUpload(file) {
        const XLS = 'application/vnd.ms-excel';
        const XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const fileReg = /^.*\.(xls|xlsx)$/i
        const _reg = /\.(xls|xlsx)$/i
        // const fileType = fileReg.test(file.type)
        const fileType = XLS === file.type || XLSX === file.type || fileReg.test(file.type) || _reg.test(file.name);
        const fileLimit = file.size / 1024 / 1024 < 10

        if (!fileType) {
          this.$message.error(this.$t('uploadTipsFirst'))
        }
        if (!fileLimit) {
          this.$message.error(this.$t('fileSizeLimit'))
        }
        return fileType && fileLimit
      },

      // 文件上传表单校验
      validatorForDoc() {
        let flags = true;
        if (this.signupUrl) {
          this.applicationError = '';
        } else {
          this.applicationError = '报名表没有上传';
          flags = false;
        }
        if (this.medicalUrl) {
          this.healthyError = '';
        } else {
          this.healthyError = '健康证明文件没有上传';
          flags = false;
        }
        return flags;
      },

      downloadFile() {
        const url = this.downloadUrl;
        const name = this.downloadName;
        
        const transferPath = this.$yioksConfig.transferBaseOnly(url)  
        downloadByJs( transferPath, name);
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  #letDownScreen {
    width: 100%;
    height: 100%;
    font-size: 14px;

    #letDown {
      height: calc(100% - 60px);
      display: flex;
      justify-content: center;
      user-select: none;

      .letDownWrap {
        width: 1024px;
        padding: 95px 0 0;
        display: flex;
        flex-direction: column;

        .logoTitle {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 0 50px 0;

          .logo {
            width: 120px;
            height: 120px;
            margin: 0 15px 0 0;
          }
        }

        .letDownBox {
          align-self: center;
          width: 900px;
          /*height: 550px;*/
          height: 610px;
          padding: 0 25px;
          background-color: $black_color;
          box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
          position: relative;
          color: $color_white;

          .title {
            display flex
            justify-content space-between
            align-items center
            margin: 10px 0 10px 0;
            border-bottom: 2px solid;
            padding-bottom: 10px;

            h2 {
              font-size: 25px;
            }
          }

          .form-wrap {

            height: 460px;

            .qualification-form-fieldset {
              margin: 0 0 20px 0;
              padding: 10px 10px 0;
              border: 1px solid $color_white;

              .code {
                width: 150px;
                margin-left: 20px;
                display: inline-block;
                line-height: 1.5;
                white-space: nowrap;
                cursor: pointer;
                text-align: center;
                outline: none;
                border-radius 4px
                padding: 8px 16px;
                background-color: $color_suc;
              }

              .waittime {
                background-color: #909399
              }
            }
          }

          .btns {
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }

  .yioks-btn
    background-color: #4CD964

  .back-icon
    width 24px
    height 24px

  .scroll-content {
    margin 0 15px
    padding-right: 10px
  }

  .w_45 {
    width 45%
  }
    .w_100 {
      width 100%
    }
  .double-line {
    width  60%
  }
  .el-upload__tip {
    color #FFFFFF
    position relative
    .download-box {
      position absolute
      top -35px
      left 90px
      color #4cd964
      text-decoration underline
      cursor pointer
    }
  }
  .example{
    position absolute
    right -37px
    font-size 16px
    top 10px
    .intro{
      text-decoration underline
      cursor pointer
      color #4cd964
    }
    .showExample{
      display none
      position absolute
      width 400px
      left -200px
      z-index 999
      background-color white
      .nameExample{
        /*text-align center*/
        color black
        text-align center
      }
      .img{
        padding 0 20px 10px
        img {
          width 100%
          height 100%
        }
      }
      &::before{
        content ''
        position absolute
        top -8px
        left 200px
        border-bottom 8px solid white
        border-right 8px solid transparent
        border-left 8px solid transparent
      }
    }
    .showExampledouble{
      display none
      position absolute
      width 600px
      left -300px
      z-index 999
      background-color white
      .nameExample{
        /*text-align center*/
        color black
        text-align center
      }
      .img{
        display flex
        padding 0 20px 10px
        .section{
          .l_title{
            font-size 14px
            color black
            text-align center
          }
          img {
            width: 100%
            /*height 100%*/
          }
        }
      }
      &::before{
        content ''
        position absolute
        top -8px
        left 300px
        border-bottom 8px solid white
        border-right 8px solid transparent
        border-left 8px solid transparent
      }
    }
    &:hover{
      .showExample{
        display: block
      }
      .showExampledouble{
        display: block
      }
    }

  }
  .w_d_100 {
    width 87%
    margin-left 30px
  }
  .w_l_100 {
    width: 110%
  }
    .w_70 {
      width  70%
    }
  .w_80 {
    width 80%
  }
  .w_90 {
    width 90%
  }
  .w_l_120 {
    width 120%
  }
</style>
<style lang="stylus">
  .form-wrap {
    .el-form-item__label {
      color: #FFFFFF;
    }

    .continue_education {
      width 53%
      margin-left 23px
    }

    .vita-edu-row {
      .el-range-separator {
        padding: 0;
      }

      .el-date-editor {
        width 323px
      }

      .orgPlace {
        width 100%
      }
    }
    $width = 306px;
    /*.birthday {
      .el-date-editor {
        width: $width;
      }
    }*/

    .gender, .national {
      .el-select {
        width: $width;
      }
    }

  }

  .recruitment {
    .el-icon-document {
      color #FFFFFF
    }
    .el-upload-list__item-name {
      color #FFFFFF
    }
  }
</style>
